var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c('base-v-component',{attrs:{"heading":"Vacations - Dashboard","link":"components/forms"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }